import { CryptoCurrency } from '@quickbit/qb-design-system';

export enum ContactStatus {
  ACTIVE = 'ACTIVE',
  PENDING_TRAVEL_RULE = 'PENDING_TRAVEL_RULE',
  PENDING_PROOF_OF_OWNERSHIP = 'PENDING_PROOF_OF_OWNERSHIP',
}

export interface Recipient {
  uuid: string;
  address: string;
  label: string;
  canApprove: boolean;
  createdBy: string;
  createdByEmail: string | null;
  approvedBy: string | null;
  approvedByEmail: string | null;
  isInternal: boolean;
  currencyCode: string;
  status: ContactStatus;
}

export interface RecipientData {
  address: string;
  label: string;
  currency: CryptoCurrency;
}
